<template>
  <div style="position: fixed; z-index: 9999; top: 70px; right: 15px">
    <transition-group tag="div">
      <div
        v-for="(alert, index) in alerts"
        :key="alert.id"
        :style="`top: ${10 * index}px; ${alert.styles}`"
        :class="`alert alert-dismissible fade show ${alert.classes}`"
        onclick="$(this).alert('close');"
        role="alert"
      >
        <Icon :name="alert.icon" />
        <span class="text">{{ alert.text }}</span>
      </div>
    </transition-group>
  </div>
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'AlertSnackBar',
  components: {
    Icon,
  },
  data() {
    return {
      alerts: [],
    };
  },
  methods: {
    addAlert(message, options = {}) {
      const alert = {
        id: Date.now(),
        text: message,
        icon: options.icon || 'info',
        classes: options.classes || 'alert-info',
        styles:
          options.styles ||
          'color: #004085; background-color: #cce5ff; border-color: #b8daff;',
      };

      this.alerts.push(alert);

      setTimeout(() => {
        this.remove(alert.id);
      }, 1000 * 10); // Remove after 10 seconds
    },
    remove(id) {
      this.alerts = this.alerts.filter((a) => a.id !== id);
    },
  },
};
</script>
<style scoped>
.alert {
  font-weight: 400;
  border-color: inherit;
  border-radius: 4px;
  background-color: transparent;
}
.alert-danger:before {
  background-color: transparent;
}
</style>
